import {makeStyles} from '@material-ui/core'

const useStyles = makeStyles(theme => ({
  root: {
    marginTop: theme.spacing(2),
  },
  paper: {
    marginBottom: theme.spacing(2),
  },
  table: {
    minWidth: 750,
    tableLayout: 'fixed',
  },
  cellRoot: {
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    minWidth: '100px',
    maxWidth: '100px',
    textOverflow: 'ellipsis',
  },
  imageSize: {
    width: 50,
    height: 50,
  },
  textWordBreak: {
    wordBreak: 'break-word',
  },
  filterListStyle: {
    width: 16,
    height: 16,
    opacity: '75%',
  },
  divOverflow: {
    overflow: 'auto',
  },
  cellCheckBox: {
    width: '65px',
    padding: '0px 12px 0 16px',
  },
  tableBody: {
    minHeight: '500px',
    maxHeight: '500px',
  },
}))

export default useStyles
